.paymentPlanSummary {
  margin: 8px 0;
  font-size: var(--font-size-16);
  line-height: var(--line-height-16);
  color: var(--payment-details__purchase-summary-color);
  border: var(--payment-details__policy-border);
  border-radius: 8px;
  padding: 16px;
}

.paymentPlanSummary button:hover > * {
  background: none;
}

.paymentPlanSummaryRowValue {
  color: var(--gray-90);
  font-weight: 500;
}

.paymentPlanSummaryTitle {
  font-size: var(--font-size-18);
  line-height: var(--line-height-28);
  color: var(--gray-90);
}

.paymentPlanSummaryHeader {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 5px;
  font-weight: 500;
}

.paymentPlanSummaryHeader button div {
  padding-right: 0;
}

.purchaseSummaryRow {
  display: flex;
  justify-content: space-between;
}

.totalCostRow {
  display: flex;
  align-items: center;
  gap: 4px;

  button {
    margin-top: 4px;

    div {
      padding: 0;
      margin: 0;
    }

    svg {
      fill: var(--brand-01);
    }
  }
}

.paymentScheduleDueDate {
  display: flex;
  align-items: center;
  gap: 4px;

  button {
    div {
      padding: 0;
      margin: 0;
    }

    svg {
      fill: var(--brand-01);
    }
  }
}

.feeBreakdownModalContent {
  margin-top: 25px;
}

.feeBreakdownSection {
  &:not(:first-of-type) {
    margin-top: 16px;
  }

  .breakdownTitle {
    font-size: var(--font-size-16);
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.32px;
    color: var(--gray-90);
  }

  .breakdownList {
    margin: 6px 0 0 0;
    padding: 0;
    list-style: none;
  }

  .breakdownListItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

.breakdownItem {
  span {
    font-size: var(--font-size-16);
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.32px;
    color: var(--gray-60);
  }

  .itemActionButton {
    font-size: var(--font-size-14);
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0.245px;
    color: var(--brand-01);
  }

  .breakdownAmount {
    font-size: var(--font-size-16);
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.32px;
    color: var(--gray-60);
  }
}

.breakdownModalButtonContainer {
  display: flex;
  justify-content: flex-end;

  button {
    margin: 32px 0 0 0;
    min-width: 70px;
  }
}
